import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { SPINNER_BORDERS, SPINNER_MARGIN, SPINNER_SIZES, SPINNER, SPINNER_RING } from './loaders.styles';

export type SpinnerSize = 'xl' | 'large' | 'medium' | 'small' | 'xs' | 'xxs';

export type SpinnerColorType =
  | 'primary'
  | 'default'
  | 'light'
  | 'subdued'
  | 'disabled'
  | 'white'
  | 'error'
  | 'success'
  | 'warn';

export type SpinningLoaderProps = CommonHTMLAttributes & {
  size?: SpinnerSize;
  color?: SpinnerColorType;
};

export const SpinningLoader = ({
  size = 'large',
  color = 'primary',
  className,
  style,
  ...rest
}: SpinningLoaderProps) => {
  const spinSize = SPINNER_SIZES[size];
  const lineSize = SPINNER_BORDERS[size];
  return (
    <div
      className={cx(SPINNER, className)}
      role='progressbar'
      style={{
        width: spinSize + SPINNER_MARGIN * 2,
        height: spinSize + SPINNER_MARGIN * 2,
        ...style,
      }}
      {...rest}
    >
      {Array.from({ length: 4 }, (_, index) => (
        <div
          key={index}
          className={SPINNER_RING}
          style={{
            width: spinSize,
            height: spinSize,
            margin: SPINNER_MARGIN,
            borderWidth: lineSize,
            borderColor: `${theme.font.colors[color]} transparent transparent transparent`,
          }}
        />
      ))}
    </div>
  );
};
